import usdtAbi from '../config/abi/erc20.json'
import Web3 from 'web3'
import BigNumber from 'bignumber.js'
import store from '../store';
//转账  转账方法这 用这个方法进行转账  懂了吗  myAddress 当前连接地址  to 合约地址  amount 数量 currencyAddredd 转账币种地址-》 paytoken
function transfer(myAddress, to, amount, currencyAddress) {
    console.log(myAddress, to, amount, currencyAddress);
    return new Promise(async function (resolve, reject) {
        let web3 = new Web3(window.web3.currentProvider);
        console.log(myAddress, to, amount, currencyAddress);
        try {
            let crossingOkContractInstance = new web3.eth.Contract(usdtAbi, currencyAddress);
            const gas = await crossingOkContractInstance.methods.transfer(to, new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()).estimateGas({ from: myAddress });
            let hash = ''
            let settled = false
            const onReceipt = receipt => {
                if (settled) return
                settled = true
                if (receipt && (receipt.status === false || receipt.status === 0 || receipt.status === '0x0')) {
                    reject(new Error('链上交易失败'))
                    return
                }
                const transactionHash = (receipt && receipt.transactionHash) || hash
                if (!transactionHash) {
                    reject(new Error('未获取到交易Hash'))
                    return
                }
                resolve(transactionHash)
            }
            const onError = error => {
                if (settled) return
                settled = true
                reject(error)
            }
            crossingOkContractInstance.methods.transfer(to, new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()).send({ from: myAddress, gas: gas, gasPrice: 5000000000 })
                .on('transactionHash', res => {
                    hash = res
                }).on('receipt', onReceipt)
                .on('error', onError)
                .then(onReceipt)
                .catch(onError)
        } catch (error) {
            reject(error)
        }
    })
}
//授权
function approve(myAddress, to, amount, currencyAddress) {
    return new Promise(async function (resolve, reject) {
        let web3 = new Web3(window.web3.currentProvider);
        let crossingOkContractInstance = new web3.eth.Contract(usdtAbi, currencyAddress);
        const gas = await crossingOkContractInstance.methods.approve(to, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()).estimateGas({ from: myAddress });
        crossingOkContractInstance.methods.approve(to, new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()).send({ from: myAddress, gas: gas, gasPrice: 5000000000 })
            .on('transactionHash', res => {

            }).on('confirmation', res => {
                resolve(res)
            }).on('error', res => {

                reject(res)
            })
    })
}


export default {
    transfer,
    approve

}
